import { ToastContainer } from "react-toastify";
import "./Editor.css";
import { Outlet } from "react-router-dom";

function Editor() {
  return (
    <div className="editor-root" onContextMenu={(e) => e.preventDefault()}>
      <Outlet />
      <ToastContainer closeButton={false} autoClose={1000} hideProgressBar />
    </div>
  );
}

export default Editor;
